import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 9.61182L12 2.89474L19 9.61182",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("line", {
      x1: "12.1089",
      y1: "3.2666",
      x2: "12.1089",
      y2: "20.9997",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }